<template>
  <div class="card height-100" id="periodeBudgetaire">
    <header class="header-card">
      <p>
        {{ $t('detailClient.generalTitle.periodeBudgetaire')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <span class="has-text-default is-italic">
            {{ $t('detailClient.periodeBudgetaire.debutMois') }}
          </span>
          <span class="has-text-default has-text-weight-semibold">
            {{ getLibelleMois(client.moisDebutPeriodeBudgetaire) }}
          </span>
        </div>
        <div class="column is-6">
          <span class="has-text-default is-italic">
            {{ $t('detailClient.periodeBudgetaire.finMois') }}
          </span>
          <span class="has-text-default has-text-weight-semibold">
            {{ getLibelleMois(client.moisFinPeriodeBudgetaire) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { LISTE_MOIS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';

export default {
  props: {
    client: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getLibelleMois(mois) {
      if (!mois) return '';
      return ucFirst(LISTE_MOIS[mois - 1]);
    },
  },
};

</script>
